<div id="wrap">
  <div id="one">
    Valve <b>  {{ branchMathValve ? branchMathValve.fullnumber.constvalue.value : "" }} </b>
  </div>
    <div  id ="two"   >
      <span *ngIf="valveStatus.val > 0 ; else valveoff" class="k-icon k-i-play k-icon-24 k-color-primary"></span>
    </div>
    <ng-template #valveoff>
      <span  class="k-icon k-i-stop-sm k-icon-24 k-color-secondary"></span>
    </ng-template>
</div>

